<template>
  <div class="Installation-process">
    <div
      class="activate-home"
      v-for="i in activateImgSrc"
      :key="i.vulae"
    >
      <!-- <img
        :src="i.stepImgUrl"
        alt=""
        class="step-img"
        @click="order(i)"
      > -->

      <!-- <div
        class="zt-text"
        v-if="i.isShow"
      > -->
      <!-- https://hswg.zjetc.cn
             https://issue.zjetc.cn -->
      <!-- 
        <a href="https://issue.zjetc.cn">
          <img
            src="../assets/zheTongImages/link.svg"
            alt=""
          >点击进入“浙江ETC”小程序</a>
      </div> -->
      <img
        class="activate-img"
        :src="i.imgUrl"
        alt
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      activateImgSrc: [
        {
          imgUrl: require('../assets/zheTongImages/ZTOBUHaveOrder_01.jpg'),
          stepImgUrl: "",
          value: 1,
          isShow: true
        },
        {
          imgUrl: require('../assets/zheTongImages/ZTOBUHaveOrder_02.jpg'),
          stepImgUrl: "",
          value: 2,
          isShow: false
        },
        {
          imgUrl: require('../assets/zheTongImages/ZTOBUHaveOrder_03.jpg'),
          stepImgUrl: "",
          value: 3,
          isShow: false
        },
        {
          imgUrl: require('../assets/zheTongImages/ZTOBUHaveOrder_04.jpg'),
          stepImgUrl: "",
          value: 4,
          isShow: false
        },
        {
          imgUrl: require('../assets/zheTongImages/ZTOBUHaveOrder_05.jpg'),
          stepImgUrl: "",
          value: 5,
          isShow: false
        },
        {
          imgUrl: require('../assets/zheTongImages/ZTOBUHaveOrder_06.jpg'),
          stepImgUrl: "",
          value: 5,
          isShow: false
        },
        // {
        //   imgUrl: require('../assets/images/OBU激活主页/OBU激活主页_01.png')
        // }
      ]
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    // order (val) {
    //   if (val.value === 4) {
    //     this.$router.push({
    //       name: 'HaveOrder'
    //     })
    //     return
    //   }
    //   if (val.value === 5) {
    //     this.$router.push({
    //       name: 'NoOrder'
    //     })
    //     return
    //   }
    // }
  },
  components: {
  }
}
</script>
<style scoped lang="scss">
.Installation-process {
  .activate-home {
    position: relative;
    .activate-img {
      width: 100%;
      height: 100%;
    }
    .step-img {
      // opacity: 0;
      width: 70%;
      height: 10%;
      z-index: 999;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .zt-text {
      z-index: 999;
      position: absolute;
      bottom: 10%;
      left: 50%;
      transform: translateX(-50%);
      width: 300px;
      a {
        font-size: 16px;
        padding-left: 40px;
        img {
          position: absolute;
          left: 9%;
          width: 16px;
        }
      }
    }
  }
  .activate-home:nth-child(4) {
    .step-img {
      bottom: 13%;
    }
  }
  .activate-home:nth-child(5) {
    .step-img {
      bottom: 18%;
    }
  }
}
</style>